import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@groupelacentrale/contact-storybook';
import { IconClose } from '@groupelacentrale/contact-storybook/lib/icons';
import { LoadingPreview } from './LoadingPreview';
import { PreviewKO } from './PreviewKO';
import './PhotoPreview.scss';

interface Props {
  file: File | string;
  onRemove: (name: string) => void | undefined;
}

export const PhotoPreview: React.FC<Props> = ({ file, onRemove }) => {
  const [src, setSrc] = useState<string | ArrayBuffer | null>();

  useEffect(() => {
    if (file instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const loadPreview = () => {
        setSrc(reader.result);
      };
      reader.addEventListener('load', loadPreview);
      return () => {
        reader.removeEventListener('load', loadPreview);
      };
    } else {
      setSrc(file);
    }
  }, [file]);

  const handleClick = useCallback(() => {
    onRemove(file instanceof File ? file.name : file);
  }, [onRemove, file]);

  if (src === undefined) {
    return <LoadingPreview />;
  }

  if (typeof src === 'string' && src) {
    return (
      <div className="photo-preview">
        <Button onClick={handleClick} theme="quaternary" icon={<IconClose width={25} />} />
        <img src={src} alt="Preview véhicule" />
      </div>
    );
  } else {
    return <PreviewKO />;
  }
};
